import React from 'react';
import styled from 'styled-components';

export type ThemeTitleIconVariant =
  | 'default'
  | 'very-negative'
  | 'negative'
  | 'neutral'
  | 'positive'
  | 'very-positive';

const StyledThemeTitleIcon = styled.div<{ variant?: ThemeTitleIconVariant }>`
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  color: white;
  flex-shrink: 0;
  display: block;
  overflow: hidden;
  background: ${({ variant }) =>
    variant === 'very-negative'
      ? 'rgba(255, 99, 132, 0.35)'
      : variant === 'negative'
        ? 'rgba(255, 99, 132, 0.22)'
        : variant === 'neutral'
          ? 'rgba(255, 216, 111, 0.55)'
          : variant === 'positive'
            ? 'rgba(129, 199, 132, 0.55)'
            : variant === 'very-positive'
              ? 'rgba(129, 199, 132, 0.38)'
              : '#EAF0FF'};
  color: ${({ variant }) =>
    variant === 'very-negative'
      ? '#881D20'
      : variant === 'negative'
        ? '#881D20'
        : variant === 'neutral'
          ? '#7D5A00'
          : variant === 'positive'
            ? '#166534'
            : variant === 'very-positive'
              ? '#166534'
              : '#1E40AF'};
  svg,
  i {
    width: 14px;
    height: 14px;
    position: absolute;
    top: 6px;
    right: 6px;
  }
`;

interface ThemeTitleIconProps {
  variant?: ThemeTitleIconVariant;
  children?: React.ReactNode;
}

const ThemeTitleIcon: React.FC<ThemeTitleIconProps> = ({ variant = 'default', children }) => (
  <StyledThemeTitleIcon variant={variant}>
    {children}
  </StyledThemeTitleIcon>
);

export default ThemeTitleIcon;
